var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDisconnect({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 20.222V24.963C27.998 27.008 26.341 28.664 24.297 28.667H7.704C5.659 28.665 4.003 27.008 4 24.964V20.223C4 19.487 4.597 18.89 5.333 18.89C6.069 18.89 6.666 19.487 6.666 20.223V24.964C6.667 25.536 7.131 26 7.703 26.001H24.296C24.868 26 25.332 25.536 25.333 24.964V20.223C25.333 19.487 25.93 18.89 26.666 18.89C27.402 18.89 27.999 19.487 27.999 20.223L28 20.222ZM15.057 21.164C15.299 21.404 15.632 21.553 16 21.553C16.368 21.553 16.701 21.404 16.943 21.164L22.868 15.239C23.116 14.997 23.271 14.658 23.271 14.284C23.271 13.548 22.674 12.951 21.938 12.951C21.564 12.951 21.226 13.105 20.984 13.353L17.334 17.003V5.99999C17.334 5.26399 16.737 4.66699 16.001 4.66699C15.265 4.66699 14.668 5.26399 14.668 5.99999V17.003L11.018 13.353C10.776 13.105 10.437 12.95 10.063 12.95C9.327 12.95 8.73 13.547 8.73 14.283C8.73 14.657 8.884 14.995 9.132 15.237L15.057 21.164Z",
    fill: "#909090"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisconnect);
export default __webpack_public_path__ + "static/media/disconnect.eb9e0a301ae656d4cea3deb35ddebf8f.svg";
export { ForwardRef as ReactComponent };